import isFunction from "lodash/isFunction";
import isBoolean from "lodash/isBoolean";
import { defineComponent as _defineComponent } from 'vue';
import { getScrollTop, getTitle, isPromise } from '@/shared/util';
import { useRoute } from 'vue-router/composables';
import { computed, onBeforeUnmount, ref } from 'vue';
import { useGoBack } from '@/shared/composables/goBack';
export default /*#__PURE__*/ _defineComponent({
    __name: 'translucent-nav-bar',
    props: {
        showBack: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: Boolean,
            default: true
        },
        background: {
            default: 'transparent'
        },
        color: {
            default: '#fff'
        },
        distance: {
            default: 80
        },
        title: null,
        beforeBack: null
    },
    emits: [
        "back"
    ],
    setup: function setup(__props, param) {
        var emit = param.emit;
        var props = __props;
        var route = useRoute();
        var title = computed(function() {
            return props.title || getTitle(route);
        });
        var canBack = computed(function() {
            var _route_meta;
            if (isBoolean((_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.canBack)) {
                var _route_meta1;
                return (_route_meta1 = route.meta) === null || _route_meta1 === void 0 ? void 0 : _route_meta1.canBack;
            }
            return props.showBack;
        });
        var goBack = useGoBack();
        var onBack = function onBack() {
            if (!canBack.value) return;
            if (isFunction(props.beforeBack)) {
                var res = props.beforeBack();
                if (isPromise(res)) {
                    res.then(function(val) {
                        if (isBoolean(val) && val) {
                            goBack();
                        }
                    });
                } else {
                    if (isBoolean(res) && res) {
                        goBack();
                    }
                }
            } else {
                goBack();
            }
            emit('back');
        };
        var opacity = ref(0);
        var onScroll = function onScroll() {
            var scrollTop = getScrollTop(window);
            opacity.value = Math.max(Math.min(scrollTop / props.distance, 1), 0);
        };
        window.addEventListener('scroll', onScroll);
        onBeforeUnmount(function() {
            window.removeEventListener('scroll', onScroll);
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            route: route,
            title: title,
            canBack: canBack,
            goBack: goBack,
            onBack: onBack,
            opacity: opacity,
            onScroll: onScroll
        };
    }
});
